module.exports = __webpack_public_path__ + "static/assets/a039ebc421d4adc2c86624fba9846a57.svg";